import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import SectionHeader from '../../../components/SectionHeader/SectionHeader';
import CardRow from '../../../components/CardRow/CardRow';
import CardRowCard from '../../../components/CardRow/CardRowCard';
import FileExport from '../../../components/FileExport/FileExport';
import DataTableBodyCellDecimal from '../../../components/DataTable/DataTableBody/DataTableBodyCell/DataTableBodyCellDecimal';
import { useGetContractRemainingQuantityExport } from '../hooks/api/contractsApi';

const StyledCardRowCard = styled(CardRowCard)`
  overflow: auto;
`;

const BorderLeftTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    border-left: 1px solid #e0e0e0;
  }
`;

const RemainingQuantity = ({ data, error, contractId }) => {
  const { getContractRemainingQuantityExport, data: exportData, error: exportError } = useGetContractRemainingQuantityExport();

  return (
    error || (
      <>
        <SectionHeader>
          <FormattedMessage id="app.contract.remainingQuantity" />
          <FileExport
            getAllEntityExport={getContractRemainingQuantityExport}
            tooltip={<FormattedMessage id={'app.dataTable.toolbarIconTooltip.export'} />}
            fileName={`EEM_export_nenakoupeneho_objemu_${contractId}.xlsx`}
            data={exportData}
            searchQuery={contractId}
            exportError={exportError}
            key={'toolbar-file-export'}
          />
        </SectionHeader>
        <CardRow>
          <StyledCardRowCard>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">M01</TableCell>
                  <TableCell align="center">M02</TableCell>
                  <TableCell align="center">M03</TableCell>
                  <BorderLeftTableCell align="center">M04</BorderLeftTableCell>
                  <TableCell align="center">M05</TableCell>
                  <TableCell align="center">M06</TableCell>
                  <BorderLeftTableCell align="center">M07</BorderLeftTableCell>
                  <TableCell align="center">M08</TableCell>
                  <TableCell align="center">M09</TableCell>
                  <BorderLeftTableCell align="center">M10</BorderLeftTableCell>
                  <TableCell align="center">M11</TableCell>
                  <TableCell align="center">M12</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[0]?.quantity} />
                  </TableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[1]?.quantity} />
                  </TableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[2]?.quantity} />
                  </TableCell>
                  <BorderLeftTableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[3]?.quantity} />
                  </BorderLeftTableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[4]?.quantity} />
                  </TableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[5]?.quantity} />
                  </TableCell>
                  <BorderLeftTableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[6]?.quantity} />
                  </BorderLeftTableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[7]?.quantity} />
                  </TableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[8]?.quantity} />
                  </TableCell>
                  <BorderLeftTableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[9]?.quantity} />
                  </BorderLeftTableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[10]?.quantity} />
                  </TableCell>
                  <TableCell align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[11]?.quantity} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[0]?.quantity + data?.quantities[1]?.quantity + data?.quantities[2]?.quantity} />
                  </TableCell>
                  <BorderLeftTableCell colSpan={3} align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[3]?.quantity + data?.quantities[4]?.quantity + data?.quantities[5]?.quantity} />
                  </BorderLeftTableCell>
                  <BorderLeftTableCell colSpan={3} align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[6]?.quantity + data?.quantities[7]?.quantity + data?.quantities[8]?.quantity} />
                  </BorderLeftTableCell>
                  <BorderLeftTableCell colSpan={3} align="center">
                    <DataTableBodyCellDecimal value={data?.quantities[9]?.quantity + data?.quantities[10]?.quantity + data?.quantities[11]?.quantity} />
                  </BorderLeftTableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <DataTableBodyCellDecimal
                      value={
                        data?.quantities[0]?.quantity +
                        data?.quantities[1]?.quantity +
                        data?.quantities[2]?.quantity +
                        data?.quantities[3]?.quantity +
                        data?.quantities[4]?.quantity +
                        data?.quantities[5]?.quantity +
                        data?.quantities[6]?.quantity +
                        data?.quantities[7]?.quantity +
                        data?.quantities[8]?.quantity +
                        data?.quantities[9]?.quantity +
                        data?.quantities[10]?.quantity +
                        data?.quantities[11]?.quantity
                      }
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </StyledCardRowCard>
        </CardRow>
      </>
    )
  );
};

RemainingQuantity.propTypes = {
  data: PropTypes.object,
  error: PropTypes.func,
  contractId: PropTypes.string,
};

export default RemainingQuantity;
